import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import { Warning, Home, Refresh } from '@mui/icons-material';
import LogoSVG from './common/LogoSVG';

function ServerError() {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${theme.palette.grey[200]} 0%, ${theme.palette.grey[100]} 100%)`,
        position: 'relative',
      }}
    >
      <Container maxWidth="md">
        <Box textAlign="center">
          <Box sx={{ mb: 4 }}>
            <LogoSVG width={200} height={60} />
          </Box>

          <Box
            sx={{
              fontSize: '120px',
              color: theme.palette.warning.main,
              mb: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'shake 0.5s ease-in-out infinite',
              '@keyframes shake': {
                '0%, 100%': { transform: 'translateX(0)' },
                '25%': { transform: 'translateX(-5px)' },
                '75%': { transform: 'translateX(5px)' },
              },
            }}
          >
            <Warning sx={{ fontSize: 'inherit' }} />
          </Box>

          <Typography variant="h1" sx={{ fontSize: '72px', fontWeight: 800, mb: 2, color: theme.palette.text.primary }}>
            500
          </Typography>

          <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
            Server Error
          </Typography>

          <Typography variant="h6" sx={{ mb: 4, color: theme.palette.text.secondary, maxWidth: '600px', mx: 'auto' }}>
            Something went wrong on our end. Our engineers have been notified and are working on it. Please try again in a few moments.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<Refresh />}
              onClick={handleRefresh}
              sx={{ px: 4, py: 1.5 }}
            >
              Try Again
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<Home />}
              onClick={() => navigate('/dashboard')}
              sx={{ px: 4, py: 1.5 }}
            >
              Go to Dashboard
            </Button>
          </Box>

          <Box sx={{ mt: 6, p: 3, bgcolor: 'background.paper', borderRadius: 2, maxWidth: '400px', mx: 'auto' }}>
            <Typography variant="body2" color="text.secondary">
              Error Reference: {new Date().getTime()}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default ServerError;
